import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
  Typography,
  DialogActions,
  Button,
  IconButton,
  DialogTitle,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { saveNote } from '../../../../store/incidentsReducer';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { incidentsApi } from '../../../../functions/IncidentsApi';
import { toast } from 'react-toastify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    background: '#2121214c',
  },
  '& .MuiPaper-root': {
    maxWidth: 800,
    width: 800,
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(3),
    borderTop: 'none',
    scrollBehavior: 'smooth',
  },
  '& .MuiDialogActions-root': {
    '& .actionButton': {
      borderColor: '#212121',
      color: '#212121',

      '&.MuiButton-contained': {
        background: '#212121',
        color: 'white',
        '&:disabled': {
          background: 'gray',
        },
      },
      '&.success': {
        '&.MuiButton-contained': {
          background: '#75ec9f',
          color: '#000000dd',
        },
      },
    },
  },
}));

export default function CreateNote({ open, setOpen }) {
  const dispatch = useDispatch();

  const [noteValue, setNoteValue] = useState('');
  const [fetchNote, setFetchNote] = useState(false);

  useEffect(() => {
    const fetchNote = async () => {
      try {
        setFetchNote(true);
        const response = await incidentsApi.getNote(open.id);

        if (response.status === 200) {
          setNoteValue(response.data.note);
          return response.data;
        } else throw new Error();
      } catch (error) {
        toast.error('Error getting note');
      } finally {
        setFetchNote(false);
      }
    };

    if (!!open && open.isHasNote && !noteValue) {
      fetchNote();
    } else if (!open && noteValue) {
      setNoteValue('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const closeHandler = () => {
    setOpen(false);
  };

  const handleSaveNote = () => {
    dispatch(saveNote(open.id, noteValue)).then((resp) => {
      if (resp) closeHandler();
    });
  };

  return (
    <BootstrapDialog
      onClose={(_, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          closeHandler();
        }
      }}
      aria-labelledby="view-incident-modal"
      open={!!open}
    >
      <DialogTitle>
        <Typography
          sx={{ fontSize: '22px', fontWeight: 500, lineHeight: '25px' }}
        >
          Notes
        </Typography>
        <IconButton
          aria-label="close"
          onClick={closeHandler}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#212121',
            zIndex: '999',
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {fetchNote ? (
          <Box
            sx={{ minHeight: '100px' }}
            className="w-100 h-100 d-flex justify-content-center align-items-center"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            <TextField
              value={noteValue}
              onChange={(e) => setNoteValue(e.target.value)}
              fullWidth
              variant="outlined"
              multiline
              rows={6}
              size="small"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          className="actionButton"
          onClick={() => setOpen(null)}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className="actionButton ms-2"
          onClick={handleSaveNote}
        >
          Save
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
